import type { LearningPositionSpineGraph } from '../services/reviewService';

const spineGraphCache = new Map<string, LearningPositionSpineGraph>();

function buildCacheKey(userId: string, subject: string) {
  return `${userId}:${subject}`;
}

export function getCachedLearningPositionSpineGraph(userId: string, subject: string) {
  return spineGraphCache.get(buildCacheKey(userId, subject)) ?? null;
}

export function setCachedLearningPositionSpineGraph(
  userId: string,
  subject: string,
  graph: LearningPositionSpineGraph,
) {
  spineGraphCache.set(buildCacheKey(userId, subject), graph);
}

export function invalidateLearningPositionSpineGraphCache(userId: string, subject?: string) {
  if (subject) {
    spineGraphCache.delete(buildCacheKey(userId, subject));
    return;
  }

  const prefix = `${userId}:`;
  for (const key of spineGraphCache.keys()) {
    if (key.startsWith(prefix)) {
      spineGraphCache.delete(key);
    }
  }
}
